/**
 * Created by fworld on 2019/6/29.
 */
const device = [
    {
        name: 'delivery.devices',
        path: 'devices',
        meta: {title: '设备列表'},
        component: () => import('@/pages/Delivery/Device/Devices'),
    },
    {
        name: 'delivery.devices.drink',
        path: 'drinks',
        meta: {title: '设备饮品'},
        component: () => import('@/pages/Delivery/Device/Devices/drink'),
    },

]

export default device
